import type { UIAnalyticsEvent } from '@atlaskit/analytics-next';
import { trackFetchErrors } from '@atlassian/jira-errors-handling/src/utils/fire-error-analytics.tsx';
import fetchJson from '@atlassian/jira-fetch/src/utils/as-json.tsx';
import { fireOperationalAnalytics } from '@atlassian/jira-product-analytics-bridge';
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import type { Action } from '@atlassian/react-sweet-state';
import { FETCH_STATUS } from '../../constants.tsx';
import type { State } from '../../types.tsx';

export type FetchOpsgenieBaseUrlResponse = {
	baseUrl: string;
};

export const fetchOpsgenieBaseUrl =
	(
		analyticsEvent?: UIAnalyticsEvent,
		// @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
		packageName: string,
	): Action<State, void, Promise<void>> =>
	async ({ getState, setState }) => {
		const { opsgenieBaseUrl: currentOpsgenieBaseUrl, fetchStatus: currentFetchStatus } = getState();

		if (
			currentOpsgenieBaseUrl !== undefined ||
			// @ts-expect-error - TS2345 - Argument of type 'FetchStatus | undefined' is not assignable to parameter of type '"SUCCESS" | "IN_PROGRESS_FETCH_STATUS"'.
			[FETCH_STATUS.inProgress, FETCH_STATUS.success].includes(currentFetchStatus)
		) {
			return;
		}

		setState({
			fetchStatus: FETCH_STATUS.inProgress,
			error: undefined,
		});

		try {
			const { baseUrl }: FetchOpsgenieBaseUrlResponse = await fetchJson(
				'/rest/internal/2/opsgenie-base-url',
			);
			analyticsEvent && fireOperationalAnalytics(analyticsEvent, 'fetchOgBaseUrl succeeded');
			setState({
				fetchStatus: FETCH_STATUS.success,
				opsgenieBaseUrl: baseUrl,
			});
			// eslint-disable-next-line @typescript-eslint/no-explicit-any
		} catch (error: any) {
			trackFetchErrors({
				error,
				id: 'fetchOgBaseUrl',
				packageName,
				sendToPrivacyUnsafeSplunk: true,
			});
			setState({
				fetchStatus: FETCH_STATUS.error,
				error,
			});
			throw error;
		}
	};
